import moment from 'moment'

import SelectField from 'modules/core/components/SelectField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  date?: string
  value?: string
  onChange: (newValue: string) => void
}

export function StartTimeSelect({ value, onChange, date }: Props) {
  const { access } = useCurrentSession()
  const now = new Date()
  const selectedDate = stringToDate(date || '', 'backend_datetime')
  const dateIsToday = moment().isSame(selectedDate, 'day')
  const is24hourFormat = access.timeFormat !== 12

  const options = Array.from({ length: 48 })
    .map((_, idx) => {
      const hour = Math.floor(idx / 2)
      const minute = idx % 2 === 0 ? 0 : 30
      const dateTime = selectedDate.clone().set({ hour, minute })

      if (dateIsToday && dateTime.isBefore(now)) {
        return null
      }

      let label: string
      if (is24hourFormat) {
        label = `${String(hour).padStart(2, '0')}:${minute === 0 ? '00' : '30'}`
      } else {
        const hour12 = hour % 12 === 0 ? 12 : hour % 12
        const ampm = hour < 12 ? 'AM' : 'PM'
        label = `${hour12}:${minute === 0 ? '00' : '30'} ${ampm}`
      }

      return { value: label, label }
    })
    .filter(Boolean)

  return (
    <SelectField
      value={value}
      label={i18n.t('forms.schedule.start_time')}
      onChange={(newValue) => onChange(newValue)}
      options={[{ value: '', label: '' }, ...options]}
    />
  )
}
